​<template>
  <b-modal :id="modalId" size="md" no-close-on-backdrop no-close-on-esc no-fade no-stacking centered>
    <template #modal-header>
      <div class="my-auto">
        <h2 class="font-weight-normal" data-test-hook="products-over-limit-modal-header">
          <div>
            <i class="far fa-warning colorOrange mr-1" data-test-hook="products-over-limit-modal-header-icon" />
            {{ $t('xYourAccountNeedsAttentionHeader') }}
          </div>
        </h2>
      </div>
      <div class="float-right">
        <b-button
          class="btn-icon-button--gray"
          variant="icon-button"
          @click="$bvModal.hide(modalId)"
          data-test-hook="x-button"
        >
          <i class="fas fa-times" />
        </b-button>
      </div>
    </template>
    <div>
      <p>
        {{ getBodyText1 }}
        <a href="https://www.generac.com/dealer-locator/" target="_blank">
          {{ $t('xOverTheLimitModalBodyText2') }}
        </a>
        {{ $t('xOverTheLimitModalBodyText3') }}
      </p>
    </div>
    <template #modal-footer>
      <b-button
        variant="secondary"
        @click="removeFromAccountButtonOnPress()"
        :disabled="billingMaintenanceFeatureFlagEnabled(currentAppConfig)"
      >
        {{ $t('xRemoveFromAccount') }}
      </b-button>
      <b-button variant="primary" @click="learnMoreButtonOnPress()">
        {{ $t('xLearnMoreLowercase') }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { mapState } from 'vuex'
import * as Constants from '@/constants'

export default {
  props: ['modalId', 'apparatusType'],
  emits: ['goToRemoveFlow'],
  computed: {
    ...mapState({
      currentAppConfig: state => state.application.currentAppConfig
    }),
    getBodyText1() {
      switch (this.apparatusType) {
        case Constants.HsbApparatusType:
          return this.$t('xOverTheLimitModalBodyText1ForHSB')
        case Constants.FuelTankApparatusType:
          return this.$t('xOverTheLimitModalBodyText1ForFM')
        default:
          return ''
      }
    }
  },
  methods: {
    removeFromAccountButtonOnPress() {
      this.$appInsights.trackEvent({
        name: 'click-remove-from-account-products-over-limit-modal',
        properties: {}
      })
      this.$bvModal.hide(this.modalId)
      this.$emit('goToRemoveFlow')
    },
    learnMoreButtonOnPress() {
      this.$appInsights.trackEvent({
        name: 'click-learn-more-products-over-limit-modal',
        properties: {}
      })
      this.$bvModal.hide(this.modalId)
      window.open(Constants.LimitReachedHelpArticleUrl)
    }
  }
}
</script>
